import * as z from 'zod';

export const IncorporationDetailsSchema = z.object({
  formationDate: z
    .string()
    .min(1, 'Corporation formation date is a required field'),
  corporationName: z
    .string()
    .trim()
    .refine((val) => val?.length > 0, {
      message: 'Please enter a valid corporation name.',
    }),
  shareCount: z.number({
    invalid_type_error: 'Please enter total number of shares issued.',
  }),
  uniqueIdentifierFromJurisdiction: z
    .number({
      invalid_type_error: 'Please enter the corporation entity number.',
    })
    .min(4, { message: 'Please enter a valid corporation entity number.' }),
  registeredAgentId: z
    .string()
    .min(1, { message: 'Please select a registered agent' }),
});

export type IncorporationDetailsSchemaFields = z.infer<
  typeof IncorporationDetailsSchema
>;
